import { useSelector } from 'react-redux';

import Item from 'classes/MenuPlan/Detail/Item';
import MenuPlan from 'classes/MenuPlan/Detail/MenuPlan';
import InputFieldSimple from 'components/desktop/_general/Input/InputFields/InputFieldSimple';
import clone from 'functions/clone';
import { RootState } from 'reducers/rootReducer';
import { regexValidationServings } from 'regex/validation/Servings';

interface IProps {
	item: Item;
	menuPlan: MenuPlan;
	setMenuPlan: (input: MenuPlan) => void;
}

const ItemInputField = (props: IProps) => {
	const reduxCurrency: string = useSelector((state: RootState) => state.currency);

	const handleValueChange = async (input: string) => {
		props.item.quantity = Number(input);
		await props.menuPlan.recalculateColumnsAndRows(reduxCurrency);
		props.setMenuPlan(clone(props.menuPlan));
	};

	const isDisabled = () => {
		if (props.menuPlan.isChild) {
			if (props.menuPlan.publishStatus === 'Closed') return false;
		} else {
			if (props.menuPlan.publishStatus === 'Editing') return false;
		}
		return true;
	};

	return (
		<InputFieldSimple
			disabled={isDisabled()}
			defaultValue={String(props.item.quantity)}
			className="form-control-sm"
			handleValueChange={handleValueChange}
			validateRegex={regexValidationServings}
			onClick={(e: React.MouseEvent<HTMLDivElement>) => {
				e.stopPropagation();
			}}
		/>
	);
};

export default ItemInputField;
